import React from "react";
import "./blogs.css";

const Sameer = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/dp/Sameer_Khan.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="Sameer"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Sameer Khan</h2>
            <small> ICICI Lombard</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction </h3>
            <p>
              "Hii! I am Sameer, and an apt way to describe myself will be the
              term ‘Y20 from Civil’. Before beginning my whole journey, let me
              pen down the expectations which I have had before entering IITK :
              landing a good job(obviously), getting a decent hold of academics,
              and finding new friends as life becomes far more beautiful and
              easy among a bunch of good and trustworthy people. And I am quite
              at peace with myself right now because I was able to achieve all
              these goals in college. Since, there are numerous things that
              people do in their campus life, I would like to break mine into
              several segments and hope each one of them might help you
              somewhere.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sammer-khan/1.jpg"
          alt="Sameer"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Academics</h3>
            <p>
              I aimed to achieve grades which were enough for me to get a hold
              of decent CPI, so you can see I was not extremely enthusiastic in
              studying everything that IITK offered. But still, some courses
              demand brutal work just to pass. You may very well be aware of
              such courses. Also, there were some courses which I found
              interesting for me. So, “it is very important to carefully add
              courses per semester”, I have not followed this advice myself in
              5th semester and I definitely paid for it.
            </p>

            <p>
              The only major challenge in IITK academics is dealing with
              compulsory courses. So my take on such courses will be that you
              have to always keep them in regular check and must assign weekly
              hours just to study those specific courses(if you are a person
              like me who loves to miss classes). In short, choosing courses at
              the beginning of semester should be done very carefully if you
              want a trouble free semester.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Co-curriculars</h3>
            <p>
              It is like a culture in IITK to recognize people with the club or
              society they are associated with and I was associated with the
              dance club. I have been Secretary at KOS Dance Club in 2nd year
              and continued to be a member of the team in my next years too. I
              committed myself to the dance club and participated in events like
              Antaragni, Thomso, Inter IIT Cult Meet, etc. Working hard for
              months, managing acads and finally getting to stage before a crowd
              of thousands really was an amazing experience. And I am surely
              going to miss that sensation forever.
            </p>
            <p>
              But you may be well aware of the fact that such activities take a
              toll on academics. The fact is quite true but still it is possible
              to manage them with other things in our life. There are many ways
              to do so. But I always remember advice from a particular senior in
              such matters, he is Nakul Zindal(Y19, coordinator of dance club)
              who once told me that he used to plan his next 3 days in advance
              in order to cope up with co-curriculars, acads and preparations
              for career opportunities. This might work well for you too. Not
              escalating it too much, I would just say that co-curricular
              activities provide you with confidence, skills, and connections,
              which are extremely useful in campus life.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sammer-khan/2.jpg"
          alt="Sameer"
        />
        <p>
          Now coming on the part to which this page is mainly dedicated -
          internship and placement.
        </p>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Internship</h3>
            <p>
              First I would like to make it clear that I failed to grab an
              internship opportunity from SPO and it has always been my habit to
              analyze past mistakes so as never to repeat them again. The main
              reasons why I did not land an internship are:
            </p>

            <ul>
              <li>
                <p>
                  Besides starting preparation earlier, never followed a
                  schedule.
                </p>
              </li>
              <li>
                <p>Lack of advice from the right people(seniors).</p>
              </li>
              <li>
                <p>
                  Gave up earlier and stopped participating in internship tests.
                </p>
              </li>
            </ul>
            <p>
              If you are preparing for internships, I do hope that you never
              make these mistakes. Talking to as many people as possible in
              relevant fields and then laying out a roadmap to follow for the
              rest of the time must help a lot in landing an internship.
            </p>
            <p>
              After the end of the SPO internship drive, I was quite hopeless to
              get an internship, and very soon, the summer of 2023 began. My
              friend Khoobayshee Aggarwal helped me in contacting an IITK alum,
              Prakhar, who offered a Web Development internship in his startup
              named Caelum. Since there were no PPO opportunities in the
              internship, I also began placement preparation in summers.
            </p>
            <p>
              Before continuing further, let me clarify that I aimed for
              software engineering related jobs, so my placement preparation
              mainly focused on honing skills related to DSA, problem solving
              and data analytics.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sammer-khan/4.jpg"
          alt="Sameer"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Placement Prep</h3>
            <p>
              I began placement prep in summer of 2023 in the following manner:
            </p>
            <ul>
              <li>
                <p>
                  Grabbed a remote internship in Web Development which only
                  demanded to work for 2-3 hours a day. This helped me in adding
                  some extra skills and work experience in my resume.
                </p>
              </li>
              <li>
                <p>
                  To prepare for technical tests and technical interviews, I
                  regularly devoted time to practicing DSA problems and puzzles.
                  As these were not the only things required in technical tests,
                  so I also learnt OOPS(I preferred in C++), SQL(DBMS), and the
                  basics of Operating System and Computer Networks. (I continued
                  to stick to this practice until placements).
                </p>
              </li>
              <li>
                <p>
                  Stayed at campus in summer and picked up courses to decrease
                  the academic burden of 7th sem
                </p>
              </li>
              <li>
                <p>
                  Completed some projects to mention in my resume (web
                  development using React, image processing, machine learning).
                </p>
              </li>
              <p>
                Though there can be several minute things to cover for
                placements but still above mentioned things can be called as a
                basic structure of my preparation in summers.
              </p>
              <p>
                Now, before arriving on the December days, let me first tell you
                how 7th sem began and ended.
              </p>
            </ul>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>7th Semester - Beginning of Placement Drive</h3>
            <p>
              First step while entering a semester, selecting the simplest OEs
              and DEs so as to minimize academic burden in placement season. And
              very soon arrived the time for making a resume. In order to
              prepare a good resume, I consulted many seniors and friends,
              received a lot of gyaan and even got help in completing some last
              resort self projects. After making the draft, I had to perform
              many changes to get the final satisfactory version of my resume.
            </p>
            <p>
              ( I made separate resume for SDE, Data Analyst and Consulting
              profile)
            </p>
            <p>
              Soon after resume submission, bombardment of technical tests
              started. I have already talked to various seniors about ‘what
              happens in tests and how to cope up with them’ and got many
              insights. But unfortunately, as everyone knows, the number of
              profiles registered for Placement Drive 2024 was almost half of
              the previous year. Soon enough, I realized that the exact advice
              of seniors might not be useful as this season is going to be a
              tough one. Hence, I preferred to apply for almost all the profiles
              which I had the slightest chance of getting accepted. In general,
              one will have to face too many tests(almost 9-10 at peak times, as
              per Y19 seniors) in 7th sem but my peak pressure was a little
              lower, but still the situation of the market being so bad had
              affected the morals of almost everyone.
            </p>
            <p>
              (Though, it was good that I had very few things to do in terms of
              coursework)
            </p>
            <p>
              Eventually after some days, we began receiving shortlists of some
              of the tests and I was mostly selected for mainly Business Analyst
              and Data Science related roles. So in parallel to the tests, I
              started preparing for the interviews too. Interview preparation
              involved mainly following steps:
            </p>
            <ul>
              <li>
                <p>
                  Prepared google docs for introduction, description of almost
                  everything mentioned in resume(work-ex, PORs, projects,
                  skills) and had all of it memorized.
                </p>
              </li>
              <li>
                <p>
                  Gathered material related to HR questions, questions related
                  to the job profile and absorbed them.
                </p>
              </li>
              <li>
                <p>
                  Started mock interviews with friends and worked on the parts
                  which needed improvement.
                </p>
              </li>
              <li>
                Most importantly, talked to people who have experienced
                interviews, those people included alums, friends at NITs(their
                placement season begins earlier) and batchmates.
              </li>
            </ul>
            <p>These measures continued till placements.</p>
          </div>
        </div>

        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sammer-khan/3.jpg"
          alt="Sameer"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Surviving Placementpalooza</h3>
            <p>
              My first interview was scheduled on Day 2.1 for an Analyst profile
              at Uniorbit. The first round involved a simple guesstimate problem
              and I made a mistake in making some assumptions, although I was
              able to solve it but still rejection was obvious from the
              interviewer's response. I continued to face rejection through Day
              2.2. It had been only 2 days and it seemed like an eternity. On
              Day 3, I had 3 interviews. First interview of the day went bizarre
              and then I headed for an interview at ICICI Lombard(which was
              going to be my destined job). The role offered was Senior
              Management Data Science. It had 2 rounds, both of them being
              technical rounds. Let me describe each round in detail:
            </p>
            <h4>Round 1:</h4>
            <p>
              First, I was asked to give a short intro, and explain the tools
              that I have used for Data Analysis. Well, I definitely did not
              make a good impression explaining that. But then they asked me
              some general questions which sounded somewhat like the steps that
              we generally use in Machine Learning projects. It had questions
              related to R2 square, KNN, as far as I remember. Overall, the
              first round was sort of bumpy for me, still I was selected for the
              2nd round.
            </p>
            <h4>Round 2:</h4>
            <p>
              It was conducted by one of the team managers. He mainly questioned
              in a way which focused on the combination of logic and data
              science. I am going to mention as many questions as I can
              remember:
            </p>
            <ul>
              <li>
                <p>
                  First was the introduction and I did not make the same
                  mistakes as in Round 1 and provided a short and relevant
                  intro.
                </p>
              </li>
              <li>
                <p>
                  Next question was “What do you know about the job profile?”
                </p>
                <ul>
                  <li>
                    This was a question that I was not ready for and I was
                    scared for a moment. But I was able to recite some of the
                    points of Job Description which I can remember and then
                    added some of my own thoughts about what will be my possible
                    responsibilities (although it is advised to talk to alums
                    from the firm for which you are to interview).
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  Next question: you are given data about the salaries of some
                  people. How would you find out the correlation in gender and
                  salary using the data?
                </p>
                <ul>
                  <li>
                    <p>
                      It is a basic question related to Correlation where you
                      are expected to replace male and female with some
                      quantifiable number.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  Next question involved outliers and I was asked to identify
                  outliers from a linear regression model(with a given
                  hyperplane) and I was able to answer it correctly.
                </p>
              </li>
              <li>
                Then the interviewer went on for questions related to the resume
                and asked about CNN.
              </li>
              <ul>
                <li>
                  <p>
                    I presented the necessary definitions and then described a
                    little of my project which involved CNN.
                  </p>
                </li>
              </ul>
              <li>
                <p>
                  He seemed satisfied with my responses and moved on for other
                  logical questions which were quite simple and relevant to the
                  puzzles from Interviewbit.
                </p>
              </li>
              <li>
                <p>
                  At last, he asked me if I had any questions so first I
                  demanded a review of the interview and then asked him to tell
                  me about his responsibilities and experience.
                </p>
              </li>
            </ul>
            <p>
              Soon after that, I received the confirmation call from HR and it
              was all over.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-8">
            <h3>Final thoughts</h3>
            <p>
              Through the course of my life at IITK, I have had a lot of
              experiences but it is quite difficult to summarize them in a
              single page, still I have tried my best to cover the major points
              related to placements. I hope it will be helpful to you. A last
              bit of advice from my side will be to talk to people whenever you
              feel stuck.
            </p>
            <p>
              There are many people inside and outside our college who will
              guide you and help you in many ways. Days at IITK have been the
              best days of my life due to the presence of certain lovely people
              who always stood besides me. I may not be able to mention them all
              here but am surely grateful for their serene existence.
            </p>
          </div>
          <div className="col-md-4">
            <img
              className="img-fluid"
              src="placement-postulates/blogs/Sammer-khan/4.jpg"
              alt="Sameer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sameer;
